



























































































































































































































import {
  toRefs,
  ref,
  reactive,
  defineComponent,
  computed
} from "@vue/composition-api";
import { useMainStore } from "@/store/storage";
import { firebase, db } from "@/firebase/firebase";
import { Area, Zone, Location } from "@/interfaces/interfaces";
import ReportPage from "@/views/reports/ReportPage.vue";

export default defineComponent({
  name: "ReportForm",
  components: {
    ReportPage
  },
  props: {
    pdisplay: {
      type: Boolean,
      default: true
    }
  },
  setup() {
    const main = useMainStore();

    interface Batch {
      order: number;
      photo: string;
      inspectionArea: string;
      inspectionZone: string;
      inspectionLocation: string;
      reference: string;
      condition: string;
    }

    const startForm = ref(null);
    const state = reactive({
      files: [],
      uploaded: [] as Batch[],
      activeArea: "",
      activeLocation: "",
      activeZone: "",
      reference: "",
      condition: "Pass",
      progress: 0,
      circleProgress: false,
      formStatus: false,
      count: 0 as number,
      console: "",
      headers: [{ text: "Photo", value: "photo" }],
      table: []
    });

    // console.log(
    //   "AREAS == ",
    //   main.state.inspectionAreas.map((e) => e.area)
    // );

    const areaSelect = computed(() => {
      return main.state.inspectionAreas.map((e: Area) => e.area);
    });
    const zoneSelect = computed(() => {
      return main.state.inspectionZones.map((e: Zone) => e.zone);
    });
    const locationSelect = computed(() => {
      return main.state.locations.map((e: Location) => e.location);
    });

    // const projectsClientFiltered = computed(() => {
    //   return main.state.projects.filter((item) => {
    //     console.log(
    //       "projectsFiltered ->  main.state.clientData.id",
    //       main.state.clientData.id,
    //       item.id
    //     );
    //     return main.state.clientData.id === item.clientId;
    //   });
    // });

    const clientHasProjects = computed(
      // () => projectsFilteredByClientId.value.length > 0
      () => {
        const tester = !!main.state.projectData.id;
        console.log("setup -> tester", tester);
        return tester;
      }
    );

    const projectId = computed(
      (): string => main.state.projectData.id as string
    );

    function addDropFile(e: File) {
      //@ts-ignore
      state.files.push(...Array.from(e.dataTransfer.files));
    }

    const counter = computed((): string => {
      const count: number = state.count + 0;
      if (!count || count < 0 || count + "" === "") state.count = 1;

      const expectedLength = 3;
      let difference = 0;
      let finalCount = "";
      const length = state.count.toString().length;

      if (length < expectedLength) {
        difference = expectedLength - length;

        while (difference--) {
          finalCount += "0";
        }

        finalCount += state.count;
      }

      return finalCount;
    });

    //PREPARE THE REFERENCE CODE
    const referenceString = computed((): string => {
      return state.reference.toUpperCase() + "-" + counter.value;
    });

    //DISPLAY PROGRESS PERCENTAGE
    const progressPercent = computed(() => {
      return Math.round(state.progress) + " %";
    });

    //SHOW LOADED FILE COUNTS
    const showUploadedFileCount = computed(() => {
      if (state.files.length === 0) {
        state.uploaded = [];
      }

      return state.uploaded.length;
    });

    function view() {
      //   state.files = e;

      //   startForm.value.validate();
      //   console.log(9, startForm.value.validate(), state.formStatus);
      //@ts-ignore
      if (startForm.value.validate()) {
        state.circleProgress = true;
        // state.count = 1;
        state.files.forEach((element: File) => {
          const tm = new Date().valueOf();
          const storageRef = firebase
            .storage()
            .ref("projects/" + state.reference + "/" + tm + "_" + element.name);
          const uploadTask = storageRef.put(element);

          // Listen for state changes, errors, and completion of the upload.
          uploadTask.on(
            firebase.storage.TaskEvent.STATE_CHANGED, // or 'state_changed'
            function(snapshot) {
              // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
              const progress =
                (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
              state.progress = progress;

              // console.log("Upload is " + progress + "% done");
              state.console = "Upload is " + progress + "% done";

              switch (snapshot.state) {
                case firebase.storage.TaskState.PAUSED: // or 'paused'
                  // console.log("Upload is paused");
                  state.console = "Upload is paused";
                  break;
                case firebase.storage.TaskState.RUNNING: // or 'running'
                  // console.log("Upload is running");
                  state.console = "Please wait, Upload is running";
                  break;
              }
            },
            function(error) {
              //@ts-ignore
              switch (error.code) {
                case "storage/unauthorized":
                  // User doesn't have permission to access the object
                  state.console = "User doesn't have permission ";
                  break;
                case "storage/canceled":
                  state.console = "Upload Cancelled";
                  // User canceled the upload
                  break;
                case "storage/unknown":
                  state.console = " Unknown error occurred,";
                  // Unknown error occurred, inspect error.serverResponse
                  break;
              }
            },
            function() {
              // Upload completed successfully, now we can get the download URL
              state.circleProgress = true;
              uploadTask.snapshot.ref
                .getDownloadURL()
                .then(function(downloadURL) {
                  //Compose Data for Database
                  ++state.count;

                  const data = {
                    order: new Date().valueOf(),
                    photo: downloadURL,
                    inspectionArea: state.activeArea,
                    inspectionZone: state.activeZone,
                    inspectionLocation: state.activeLocation,
                    condition: state.condition,
                    reference: referenceString.value
                  };

                  db.collection("projects")
                    .doc(projectId.value)
                    .collection("reports")
                    .add(data)
                    .then(() => {
                      state.uploaded.push(data);
                      // console.log("File available at", downloadURL);
                      state.console = "File available at : " + downloadURL;
                      state.console = " Upload completed";

                      state.circleProgress = false;
                      state.progress = 0;
                    })
                    .catch();
                  state.console = "All Images Uploaded";
                });
            }
          );
        });
      }
    }

    return {
      ...toRefs(state),
      main: main.state,
      view,
      areaSelect,
      locationSelect,
      zoneSelect,
      startForm,
      addDropFile,
      clientHasProjects,
      counter,
      referenceString,
      progressPercent,
      showUploadedFileCount
    };
  }
});
